class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.isExpanded = false;
  }

  connectedCallback() {
    this.fullContent = this.getAttribute('full-content') || '';
    this.shortContent = this.getAttribute('short-content') || '';
    this.desktopLimit = parseInt(this.getAttribute('desktop-limit')) || 160;
    this.mobileLimit = parseInt(this.getAttribute('mobile-limit')) || 80;

    this.enableDesktop = this.getAttribute('enable-desktop') !== 'false'; 
    this.enableMobile = this.getAttribute('enable-mobile') !== 'false'; 

    this.render();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  isDesktop() {
    return window.innerWidth > 768;
  }

  getCurrentLimit() {
    return this.isDesktop() ? this.desktopLimit : this.mobileLimit;
  }

  isEnabled() {
    return this.isDesktop() ? this.enableDesktop : this.enableMobile;
  }

  handleResize() {
    if (!this.isExpanded) {
      this.render();
    }
  }

  render() {
    const limit = this.getCurrentLimit();
    const enabled = this.isEnabled();
    const isTruncated = this.fullContent.length > limit;
    const contentToShow = this.isExpanded || !enabled ? this.fullContent : this.fullContent.slice(0, limit);

    this.shadowRoot.innerHTML = `
      <style>
        .read-more-link {
          color: #053835;
          cursor: pointer;
          text-decoration: underline;
          display: block; margin-bottom: 10px
        }
        .content p {
          color: var(--color)
        }
      </style>
      <span class="content">${contentToShow}${!this.isExpanded && enabled && isTruncated ? '...' : ''}</span>
      ${enabled && isTruncated ? `<span class="read-more-link">${this.isExpanded ? 'Read less' : 'Read more'}</span>` : ''}
    `;

    this.shadowRoot.querySelector('.read-more-link')?.addEventListener('click', () => {
      this.isExpanded = !this.isExpanded;
      this.render();
    });
  }
}

customElements.define('read-more', ReadMore);
